export const guestComps = {
  detail: {
    nav: {
      overview: "Informazioni",
      bookings: "Prenotazioni",
      checkins: "Check-in",
      invoicing: "Fatturazione",
    },
    personalInfo: "Informazioni personali",
    contactInfo: "Informazioni di contatto",
    residenceInfo: "Informazioni sulla residenza",
    fields: {
      firstName: "Nome",
      lastName: "Cognome",
      document: "Documento",
      nationality: "Nazionalità",
      country: "Paese",
      birthDate: "Data di nascita",
      email: "Email",
      whatsapp: "WhatsApp",
      countryResidence: "Paese di residenza",
      cityResidence: "Città di residenza",
      relationship: "Parentela",
    },
    cols: {
      code: "Codice",
      accommodation: "Alloggio",
      checkIn: "Check-in",
      checkOut: "Check-out",
      status: "Stato",
      total: "Totale",
      guest: "Ospite",
      booking: "Prenotazione",
      entryDate: "Data di ingresso",
      date: "Data",
    },
    confirmed: "Confermata",
    fiscalProfile: "Profilo fiscale registrato",
    legalName: "Denominazione legale",
    taxId: "Codice fiscale",
    type: "Tipo",
    company: "Società",
    individual: "Persona fisica",
    invoicesIssued: "Fatture emesse",
    empty: {
      bookings: "Nessuna prenotazione registrata per questo ospite.",
      checkins: "Nessun check-in registrato per questo ospite.",
      invoices: "Nessuna fattura emessa per questo ospite.",
    },
    noPdf: "Nessun PDF",
    status: {
      sent: "Emessa",
      processing: "In elaborazione",
      error: "Errore",
      pending: "In sospeso",
    },
    close: "Chiudi",
  },
  form: {
    editTitle: "Modifica cliente",
    newTitle: "Nuovo cliente",
    subtitle: "Dati di contatto e di fatturazione per prenotazioni e fatture future.",
    subtitleEmbedded: "Completa il profilo e tornerai alla fattura senza perdere gli addebiti.",
    backToInvoice: "Torna alla fattura",
    close: "Chiudi",
    customerTypeAria: "Tipo di cliente",
    typeIndividual: "Persona fisica",
    typeIndividualHelp: "Persona fisica",
    typeCompany: "Società",
    typeCompanyHelp: "Persona giuridica",
    identity: "Identità",
    identityDesc: "Dati che identificano il destinatario della fattura.",
    name: "Nome",
    namePlaceholder: "Mario",
    lastName: "Cognome",
    lastNamePlaceholder: "Rossi",
    legalName: "Ragione sociale",
    legalNamePlaceholder: "Azienda Esempio S.r.l.",
    docTaxId: "NIF / CIF / VAT",
    docFiscal: "Documento fiscale",
    docPlaceholderIndividual: "DNI, NIE o passaporto",
    docType: "Tipo di documento",
    select: "Seleziona",
    docDni: "DNI",
    docNie: "NIE",
    docPassport: "Passaporto",
    docOther: "Altro documento",
    contact: "Contatto",
    contactDesc: "Canali per inviare la fattura o contattare il cliente.",
    email: "Email",
    emailPlaceholder: "customer@email.com",
    phone: "Telefono",
    fiscalAddress: "Indirizzo fiscale",
    fiscalAddressDesc: "Usato come indirizzo del destinatario su una fattura completa.",
    country: "Paese",
    address: "Indirizzo",
    addressPlaceholder: "Via, numero e piano",
    city: "Città",
    cityPlaceholder: "Madrid",
    state: "Provincia / Stato",
    postalCode: "Codice postale",
    postalPlaceholder: "28001",
    requiredNote: "* Campi obbligatori per il profilo fiscale",
    backToInvoiceShort: "Torna alla fattura",
    cancel: "Annulla",
    saving: "Salvataggio…",
    saveChanges: "Salva modifiche",
    createClient: "Crea cliente",
    err: {
      name: "Inserisci il nome.",
      lastName: "Inserisci il cognome.",
      legalName: "Inserisci la ragione sociale.",
      taxId: "L'identificazione fiscale è obbligatoria per le società.",
      country: "Seleziona il paese.",
      address: "Inserisci l'indirizzo fiscale.",
      city: "Inserisci la città.",
      postalCode: "Inserisci il codice postale.",
      email: "Inserisci un'email valida.",
      saveFailed: "Impossibile salvare il cliente.",
    },
  },
  list: {
    title: "Clienti di fatturazione",
    subtitle: "Profili fiscali riutilizzabili per emettere e consultare le fatture",
    searchLabel: "Cerca clienti",
    searchPlaceholder: "Nome, email, telefono o documento…",
    clearSearch: "Cancella ricerca",
    exporting: "Esportazione...",
    exportClients: "Esporta clienti",
    newClient: "Nuovo cliente",
    cols: {
      fiscalClient: "Cliente fiscale",
      contact: "Contatto",
      fiscalDocument: "Documento fiscale",
      country: "Paese",
      linkedBookings: "Prenotazioni collegate",
      invoices: "Fatture",
      actions: "Azioni",
    },
    company: "Società",
    individual: "Persona fisica",
    noEmail: "Nessuna email assegnata",
    noPhone: "Nessun telefono assegnato",
    viewInvoicesTitle: "Visualizza {count} fattura per questo ospite | Visualizza {count} fatture per questo ospite",
    invoicesCount: "{count} fattura | {count} fatture",
    noInvoices: "Nessuna fattura",
    editClient: "Modifica cliente",
    edit: "Modifica",
    viewDetail: "Visualizza dettaglio",
    view: "Visualizza",
    emptySearchTitle: "Nessun profilo fiscale trovato",
    emptySearchSub: "Nessun cliente di fatturazione corrisponde a “{term}”.",
    emptyTitle: "Nessun cliente di fatturazione",
    emptySub: "Crea un profilo fiscale al momento dell'emissione di una fattura oppure salvane uno ora per riutilizzarlo in seguito.",
    createFirst: "Crea il primo cliente",
    selectedClient: "Cliente selezionato",
  },
  internalName: {
    addBtn: "nome interno",
    title: "Nome interno",
    hint: "Solo tu puoi vederlo. Appare prima del nome pubblico nei tuoi elenchi e calendari.",
    removeWarn: "Verrà rimosso dai tuoi elenchi. I messaggi con il codice di accesso e l'Agente IA non indicheranno più a quale alloggio si riferisce.",
    edit: "Modifica",
    cancel: "Annulla",
    removing: "Rimozione…",
    confirmRemove: "Sì, rimuovi",
    remove: "Rimuovi",
    editTitle: "Modifica nome interno",
    addTitle: "Aggiungi nome interno",
    eyebrow: "Nome interno dell'alloggio",
    modalHint: "Un nome privato per riconoscere l'alloggio a colpo d'occhio (per esempio «Roser Attic» o «Secondo»). I tuoi ospiti non lo vedono mai.",
    placeholder: "Roser Attic",
    previewLabel: "Lo vedrai così",
    saving: "Salvataggio…",
    save: "Salva",
    saveFailed: "Impossibile salvare il nome interno.",
  },
};
